/**
 * SEO 配置 - models (Français)
 */

export default {
    veo_3_1: {
        title: 'Google Veo 3.1 - Générateur vidéo IA phare | WeryAI',
        description: 'Google Veo 3.1 : Modèle vidéo IA phare avec audio natif.',
        keywords: 'Google Veo 3.1, vidéo IA phare, générateur vidéo IA, WeryAI',
    },
    veo_3: {
        title: 'veo 3 Génération Vidéo et Image IA | WeryAI',
        description: 'Experience veo 3 on WeryAI. High-quality results.',
        keywords: 'veo_3, AI, WeryAI',
    },
    veo_3_fast: {
        title: 'veo 3 fast Génération Vidéo et Image IA | WeryAI',
        description: 'Experience veo 3 fast on WeryAI. High-quality results.',
        keywords: 'veo_3_fast, AI, WeryAI',
    },
    sora_2: {
        title: 'sora 2 Génération Vidéo et Image IA | WeryAI',
        description: 'Experience sora 2 on WeryAI. High-quality results.',
        keywords: 'sora_2, AI, WeryAI',
    },
    weryai_video_1: {
        title: 'WeryAI Video 1.0 Génération Vidéo IA | WeryAI',
        description: 'WeryAI Video 1.0 pour créer des vidéos IA cinématographiques.',
        keywords: 'WeryAI Video 1.0, vidéo IA, WeryAI',
    },
    weryai_image_2: {
        title: 'WeryAI Image 2.0 Génération Image IA | WeryAI',
        description: 'WeryAI Image 2.0 pour générer des images IA de qualité studio.',
        keywords: 'WeryAI Image 2.0, image IA, WeryAI',
    },
    image_grok_2: {
        title: 'Grok-2 Générateur Images - xAI | WeryAI',
        description: 'Découvrez Grok-2 de xAI sur WeryAI.',
        keywords: 'Grok-2, xAI, image IA, WeryAI',
    },
    kling_ai: {
        title: 'kling ai Génération Vidéo et Image IA | WeryAI',
        description: 'Experience kling ai on WeryAI. High-quality results.',
        keywords: 'kling_ai, AI, WeryAI',
    },
    runway_ai: {
        title: 'runway ai Génération Vidéo et Image IA | WeryAI',
        description: 'Experience runway ai on WeryAI. High-quality results.',
        keywords: 'runway_ai, AI, WeryAI',
    },
    hailuo_23: {
        title: 'hailuo 23 Génération Vidéo et Image IA | WeryAI',
        description: 'Experience hailuo 23 on WeryAI. High-quality results.',
        keywords: 'hailuo_23, AI, WeryAI',
    },
    hailuo_ai: {
        title: 'hailuo ai Génération Vidéo et Image IA | WeryAI',
        description: 'Experience hailuo ai on WeryAI. High-quality results.',
        keywords: 'hailuo_ai, AI, WeryAI',
    },
    pika_2_2: {
        title: 'pika 2 2 Génération Vidéo et Image IA | WeryAI',
        description: 'Experience pika 2 2 on WeryAI. High-quality results.',
        keywords: 'pika_2_2, AI, WeryAI',
    },
    seedance: {
        title: 'seedance Génération Vidéo et Image IA | WeryAI',
        description: 'Experience seedance on WeryAI. High-quality results.',
        keywords: 'seedance, AI, WeryAI',
    },
    wan_2_6: {
        title: `Wan 2.6 | Générateur de vidéo IA avancé d'Alibaba | WeryAI`,
        description: `Wan 2.6 est le dernier modèle multimodal phare d'Alibaba pour la génération de vidéos IA, avec une qualité cinématographique en 1080p, une synchronisation audio-vidéo native et des capacités narratives multi-plans intelligentes. Essayez-le gratuitement sur WeryAI.`,
        keywords: 'Wan 2.6, Alibaba Wan 2.6, générateur de vidéo IA, modèle vidéo multimodal, texte vers vidéo, image vers vidéo, synchronisation audio, WeryAI Wan 2.6',
    },
    wan_ai: '',
    image_gpt_4o: {
        title: `GPT-4o Générateur d'Images - IA d'Image Native OpenAI | WeryAI`,
        description: `Générez des images IA avec GPT-4o. Compréhension sémantique puissante et sortie visuelle de haute qualité. Essayez gratuitement sur WeryAI.`,
        keywords: 'GPT-4o, OpenAI image, art IA, génération image, WeryAI',
    },
    image_nano_banana_pro: {
        title: 'Nano Banana Pro - Génération images Google Gemini 3.0 Pro | WeryAI',
        description: 'Modèle IA basé sur le raisonnement. Qualité 4K ultra-réaliste.',
        keywords: 'Nano Banana Pro, Gemini 3.0 Pro, génération images IA, WeryAI',
    },
    image_nano_banana: {
        title: 'Google Nano Banana - Dessin rapide Gemini 2.5 Flash | WeryAI',
        description: 'Générateur images IA ultra-rapide de Google DeepMind.',
        keywords: 'Nano Banana, Gemini 2.5 Flash, dessin rapide, WeryAI',
    },
    image_flux: {
        title: 'Générateur images FLUX AI - Modèle open source | WeryAI',
        description: 'FLUX développé par l\'équipe Stable Diffusion. Qualité visuelle exceptionnelle.',
        keywords: 'FLUX, AI, génération images, WeryAI',
    },
    image_flux_kontext: {
        title: 'FLUX.1 Kontext - Amélioration professionnelle du dessin IA | WeryAI',
        description: 'FLUX.1 Pro et Max avec rendu de texte amélioré.',
        keywords: 'FLUX Kontext, FLUX Pro, FLUX Max, WeryAI',
    },
    image_imagen: {
        title: 'Google Imagen 4 - Modèle de diffusion texte vers image | WeryAI',
        description: 'Générez des images photoréalistes et artistiques avec Google Imagen 4.',
        keywords: 'Imagen 4, Google AI, diffusion, WeryAI',
    },
    image_qwen_image: {
        title: 'Qwen Image - Modèle de rendu de texte Alibaba | WeryAI',
        description: 'Modèle image IA Alibaba pour le rendu de texte multilingue.',
        keywords: 'Qwen Image, Alibaba, rendu de texte, WeryAI',
    },
    image_wan_ai: {
        title: 'Wan 2.5 Génération images - Modèle haute fidélité | WeryAI',
        description: 'Wan 2.5 avec suivi précis des prompts et rendu photographique.',
        keywords: 'Wan AI, Wan 2.5, génération images, WeryAI',
    },
    image_seendream: {
        title: 'Seedream 4.0 - Modèle de dessin 4K par lots ByteDance | WeryAI',
        description: 'Modèle de dessin ultra-rapide ByteDance avec traitement par lots.',
        keywords: 'Seedream, ByteDance, dessin 4K, WeryAI',
    },
    image_dreamina: {
        title: 'Dreamina 4.0 - Modèle de création images IA ByteDance | WeryAI',
        description: 'Dreamina 4.0 pour la conversion croquis vers image.',
        keywords: 'Dreamina 4.0, ByteDance, création images IA, WeryAI',
    },
    image_seedream_4_5: {
        title: "Seedream 4.5 - Modèle de Génération d'Images IA Phare de ByteDance | WeryAI",
        description: "Seedream 4.5 est le dernier modèle d'image IA phare de ByteDance, axé sur le rendu typographique précis et la fusion multi-images avec sortie 4K ultra HD. Essayez-le gratuitement sur WeryAI.",
        keywords: "Seedream 4.5, génération d'images IA, rendu typographique, fusion d'images, ByteDance, qualité 4K, WeryAI",
    },
    image_midjourney: {
        title: `Midjourney - Génération d'images flexible, détaillée et vibrante | WeryAI`,
        description: `Midjourney est un modèle d'image IA phare d'un laboratoire de recherche indépendant, réputé pour son esthétique artistique. Essayez-le gratuitement sur WeryAI.`,
        keywords: `Midjourney, génération d'images IA, création artistique, qualité d'éclairage, rendu de texte, portraits hyperréalistes, WeryAI`,
    },
    runway_4_5: {
        title: 'Runway Gen-4.5 Générateur Vidéo IA - Créez des Vidéos Cinématographiques | WeryAI',
        description: `Créez des vidéos impressionnantes avec Runway Gen-4.5 sur WeryAI. Architecture hybride autorégressive-diffusion pour une simulation physique précise et une cohérence temporelle.`,
        keywords: 'Runway Gen-4.5, générateur vidéo IA, vidéo IA cinématographique, simulation physique, Runway AI, WeryAI',
    },
    kling_2_6_pro: {
        title: 'Kling 2.6 Pro Générateur Vidéo IA - Création Vidéo Haute Qualité | WeryAI',
        description: `Générez des vidéos haute qualité avec Kling 2.6 Pro sur WeryAI. Génération audiovisuelle native, qualité cinématographique 1080p, excellente adhérence aux prompts.`,
        keywords: 'Kling 2.6 Pro, générateur vidéo IA, vidéo IA haute qualité, Kling AI, WeryAI',
    },
    video_dreamina_3: {
        title: 'Dreamina 3.0 Générateur Vidéo - Contrôle caméra précis et guidage de frames | WeryAI',
        description: `Générez des vidéos IA cinématographiques avec Dreamina 3.0 (Jimeng 3.0) sur WeryAI. Contrôle précis des frames début/fin, mouvements de caméra professionnels et génération vidéo 1080p haute dynamique.`,
        keywords: 'Dreamina 3.0, Jimeng Video 3.0, générateur vidéo IA, contrôle caméra, frames début fin, ByteDance AI, WeryAI',
    },
    kling_o1: {
        title: 'Kling O1 Générateur Vidéo IA - Génération Vidéo Créative | WeryAI',
        description: `Libérez votre créativité sur WeryAI avec le générateur vidéo IA Kling O1. Parfait pour générer du contenu vidéo imaginatif et unique.`,
        keywords: 'Kling O1, générateur vidéo IA, vidéo IA créative, Kling AI, WeryAI',
    },
}
